import { fullName, fmtDateTime } from "./format";

// Représentation lisible d'un enregistrement (titres de fiche, références) :
// jamais l'identifiant brut quand un nom, un titre ou un libellé existe.
export const recordRepresentation = (r) => {
  if (!r || typeof r !== "object") return "";
  const person = fullName(r.firstName, r.lastName);
  if (person) return person;
  if (r.firstNamePatient || r.firstNamePro) {
    const who = [fullName(r.firstNamePatient, r.lastNamePatient), fullName(r.firstNamePro, r.lastNamePro)]
      .filter(Boolean)
      .join(" → ");
    const when = r?.slot?.startTime ? ` · ${fmtDateTime(r.slot.startTime)}` : "";
    return `${who}${when}`;
  }
  const label = r.name || r.title || r.label || r.jobName || r.code || r.subject || r.email || r.description;
  if (label) return String(label).length > 80 ? `${String(label).slice(0, 77)}…` : String(label);
  if (r.value != null && typeof r.value !== "object") return String(r.value);
  return "Détail";
};

export default recordRepresentation;
